// DO NOT EDIT -- generated from fs/services/orgs/orgs.proto

import { AuthToken } from './auth.proto';
import { CardInfo, CustomSeatRequestConfig, EmailStatus, Invite, Invoice, NotificationConfig, Org, OrgID, OrgOrUmbrellaID, PlanStage, Platform, Role, Seat, SeatID, SessionOverageConfig, SetupStage, SubscriptionDetails, Umbrella, UmbrellaID, UmbrellaInvite } from './model.proto';
import { ListUpdate } from './recording.proto';
import * as flags from '../../shared/flags';
import * as protobuf from '../../../google/protobuf';

/**
 * This exposes the service as a typescript API but currently only the admin UI has access.
 * To expose endpoints to the app add them to OrgsServicePublic.
 * ////////////////////////
 * Org management
 * ////////////////////////
 */
export namespace Orgs {

  export const GetOrgEndpoint = "/grpc/orgs.Orgs/GetOrg";
  export function GetOrg(sender: (req: OrgID, endpoint: string) => Promise<Org>, req: OrgID): { promise: () => Promise<Org>, endpoint: string } {
    return {
      promise: () => sender(req, GetOrgEndpoint),
      endpoint: GetOrgEndpoint
    };
  }

  export const GetEntityNameEndpoint = "/grpc/orgs.Orgs/GetEntityName";
  export function GetEntityName(sender: (req: OrgOrUmbrellaID, endpoint: string) => Promise<EntityName>, req: OrgOrUmbrellaID): { promise: () => Promise<EntityName>, endpoint: string } {
    return {
      promise: () => sender(req, GetEntityNameEndpoint),
      endpoint: GetEntityNameEndpoint
    };
  }

  // unsupported streaming endpoint
  export const EnumerateOrgIDsEndpoint = "/grpc/orgs.Orgs/EnumerateOrgIDs";

  export const BatchEvaluateFlagsEndpoint = "/grpc/orgs.Orgs/BatchEvaluateFlags";
  /**
   * BatchEvaluateFlags provides a way to evaluate flags for a set of orgs at once.
   * This is primarily meant for workloads that do not operate in a single org context (e.g. dataflow).
   * There is a limit of 1000 orgs per evaluation request.
   */
  export function BatchEvaluateFlags(sender: (req: BatchEvaluateFlagsRequest, endpoint: string) => Promise<BatchEvaluateFlagsResponse>, req: BatchEvaluateFlagsRequest): { promise: () => Promise<BatchEvaluateFlagsResponse>, endpoint: string } {
    return {
      promise: () => sender(req, BatchEvaluateFlagsEndpoint),
      endpoint: BatchEvaluateFlagsEndpoint
    };
  }

  // unsupported streaming endpoint
  export const EnumerateNonDeletedOrgIDsEndpoint = "/grpc/orgs.Orgs/EnumerateNonDeletedOrgIDs";

  export const ProvisionOrgEndpoint = "/grpc/orgs.Orgs/ProvisionOrg";
  export function ProvisionOrg(sender: (req: ProvisionRequest, endpoint: string) => Promise<ProvisionResponse>, req: ProvisionRequest): { promise: () => Promise<ProvisionResponse>, endpoint: string } {
    return {
      promise: () => sender(req, ProvisionOrgEndpoint),
      endpoint: ProvisionOrgEndpoint
    };
  }

  export const CancelEndpoint = "/grpc/orgs.Orgs/Cancel";
  export function Cancel(sender: (req: OrgOrUmbrellaID, endpoint: string) => Promise<CancelResponse>, req: OrgOrUmbrellaID): { promise: () => Promise<CancelResponse>, endpoint: string } {
    return {
      promise: () => sender(req, CancelEndpoint),
      endpoint: CancelEndpoint
    };
  }

  export const UpdateShareSettingsEndpoint = "/grpc/orgs.Orgs/UpdateShareSettings";
  export function UpdateShareSettings(sender: (req: ShareSettingsUpdate, endpoint: string) => Promise<UpdateShareSettingsResponse>, req: ShareSettingsUpdate): { promise: () => Promise<UpdateShareSettingsResponse>, endpoint: string } {
    return {
      promise: () => sender(req, UpdateShareSettingsEndpoint),
      endpoint: UpdateShareSettingsEndpoint
    };
  }

  export const UpdateDataExportSettingsEndpoint = "/grpc/orgs.Orgs/UpdateDataExportSettings";
  export function UpdateDataExportSettings(sender: (req: UpdateDataExportRequest, endpoint: string) => Promise<{}>, req: UpdateDataExportRequest): { promise: () => Promise<{}>, endpoint: string } {
    return {
      promise: () => sender(req, UpdateDataExportSettingsEndpoint),
      endpoint: UpdateDataExportSettingsEndpoint
    };
  }

  export const UpdateOrgAdminInfoEndpoint = "/grpc/orgs.Orgs/UpdateOrgAdminInfo";
  export function UpdateOrgAdminInfo(sender: (req: UpdateOrgAdminInfoRequest, endpoint: string) => Promise<{}>, req: UpdateOrgAdminInfoRequest): { promise: () => Promise<{}>, endpoint: string } {
    return {
      promise: () => sender(req, UpdateOrgAdminInfoEndpoint),
      endpoint: UpdateOrgAdminInfoEndpoint
    };
  }

  export const UpdateSubscriptionDetailsEndpoint = "/grpc/orgs.Orgs/UpdateSubscriptionDetails";
  export function UpdateSubscriptionDetails(sender: (req: UpdateSubscriptionDetailsRequest, endpoint: string) => Promise<UpdateSubscriptionDetailsResponse>, req: UpdateSubscriptionDetailsRequest): { promise: () => Promise<UpdateSubscriptionDetailsResponse>, endpoint: string } {
    return {
      promise: () => sender(req, UpdateSubscriptionDetailsEndpoint),
      endpoint: UpdateSubscriptionDetailsEndpoint
    };
  }

  export const UpdateEmailStatusEndpoint = "/grpc/orgs.Orgs/UpdateEmailStatus";
  export function UpdateEmailStatus(sender: (req: UpdateEmailStatusRequest, endpoint: string) => Promise<{}>, req: UpdateEmailStatusRequest): { promise: () => Promise<{}>, endpoint: string } {
    return {
      promise: () => sender(req, UpdateEmailStatusEndpoint),
      endpoint: UpdateEmailStatusEndpoint
    };
  }

  export const UpdateOrgLevel0Endpoint = "/grpc/orgs.Orgs/UpdateOrgLevel0";
  export function UpdateOrgLevel0(sender: (req: UpdateOrgLevel0Request, endpoint: string) => Promise<{}>, req: UpdateOrgLevel0Request): { promise: () => Promise<{}>, endpoint: string } {
    return {
      promise: () => sender(req, UpdateOrgLevel0Endpoint),
      endpoint: UpdateOrgLevel0Endpoint
    };
  }

  export const MarkOrgNukingEndpoint = "/grpc/orgs.Orgs/MarkOrgNuking";
  export function MarkOrgNuking(sender: (req: MarkOrgNukingRequest, endpoint: string) => Promise<MarkOrgNukingResponse>, req: MarkOrgNukingRequest): { promise: () => Promise<MarkOrgNukingResponse>, endpoint: string } {
    return {
      promise: () => sender(req, MarkOrgNukingEndpoint),
      endpoint: MarkOrgNukingEndpoint
    };
  }

  export const TombstoneOrgEndpoint = "/grpc/orgs.Orgs/TombstoneOrg";
  export function TombstoneOrg(sender: (req: OrgID, endpoint: string) => Promise<TombstoneOrgResponse>, req: OrgID): { promise: () => Promise<TombstoneOrgResponse>, endpoint: string } {
    return {
      promise: () => sender(req, TombstoneOrgEndpoint),
      endpoint: TombstoneOrgEndpoint
    };
  }

  export const RemoveOrgSeatsAndPersonsEndpoint = "/grpc/orgs.Orgs/RemoveOrgSeatsAndPersons";
  export function RemoveOrgSeatsAndPersons(sender: (req: OrgID, endpoint: string) => Promise<{}>, req: OrgID): { promise: () => Promise<{}>, endpoint: string } {
    return {
      promise: () => sender(req, RemoveOrgSeatsAndPersonsEndpoint),
      endpoint: RemoveOrgSeatsAndPersonsEndpoint
    };
  }

  export const UpdateHiddenCustomVarsEndpoint = "/grpc/orgs.Orgs/UpdateHiddenCustomVars";
  /** Deprecated. Use fieldmeta instead. */
  export function UpdateHiddenCustomVars(sender: (req: UpdateCustomVarsRequest, endpoint: string) => Promise<{}>, req: UpdateCustomVarsRequest): { promise: () => Promise<{}>, endpoint: string } {
    return {
      promise: () => sender(req, UpdateHiddenCustomVarsEndpoint),
      endpoint: UpdateHiddenCustomVarsEndpoint
    };
  }

  export const UpdateInactivityTimeoutSettingsEndpoint = "/grpc/orgs.Orgs/UpdateInactivityTimeoutSettings";
  export function UpdateInactivityTimeoutSettings(sender: (req: UpdateInactivityTimeoutSettingsRequest, endpoint: string) => Promise<{}>, req: UpdateInactivityTimeoutSettingsRequest): { promise: () => Promise<{}>, endpoint: string } {
    return {
      promise: () => sender(req, UpdateInactivityTimeoutSettingsEndpoint),
      endpoint: UpdateInactivityTimeoutSettingsEndpoint
    };
  }

  export const UpdateOrgCreateSeatsDisabledEndpoint = "/grpc/orgs.Orgs/UpdateOrgCreateSeatsDisabled";
  export function UpdateOrgCreateSeatsDisabled(sender: (req: UpdateOrgCreateSeatsDisabledRequest, endpoint: string) => Promise<{}>, req: UpdateOrgCreateSeatsDisabledRequest): { promise: () => Promise<{}>, endpoint: string } {
    return {
      promise: () => sender(req, UpdateOrgCreateSeatsDisabledEndpoint),
      endpoint: UpdateOrgCreateSeatsDisabledEndpoint
    };
  }

  export const ForceTrialExpireEndpoint = "/grpc/orgs.Orgs/ForceTrialExpire";
  /** Used for testing. Forcibly expires an org, as if it's trial had expired */
  export function ForceTrialExpire(sender: (req: ForceTrialExpireRequest, endpoint: string) => Promise<{}>, req: ForceTrialExpireRequest): { promise: () => Promise<{}>, endpoint: string } {
    return {
      promise: () => sender(req, ForceTrialExpireEndpoint),
      endpoint: ForceTrialExpireEndpoint
    };
  }

  export const UpdateFirstRecordEndpoint = "/grpc/orgs.Orgs/UpdateFirstRecord";
  export function UpdateFirstRecord(sender: (req: UpdateFirstRecordRequest, endpoint: string) => Promise<UpdateFirstRecordResponse>, req: UpdateFirstRecordRequest): { promise: () => Promise<UpdateFirstRecordResponse>, endpoint: string } {
    return {
      promise: () => sender(req, UpdateFirstRecordEndpoint),
      endpoint: UpdateFirstRecordEndpoint
    };
  }

  export const GetPaymentInfoEndpoint = "/grpc/orgs.Orgs/GetPaymentInfo";
  export function GetPaymentInfo(sender: (req: OrgOrUmbrellaID, endpoint: string) => Promise<PaymentInfoResponse>, req: OrgOrUmbrellaID): { promise: () => Promise<PaymentInfoResponse>, endpoint: string } {
    return {
      promise: () => sender(req, GetPaymentInfoEndpoint),
      endpoint: GetPaymentInfoEndpoint
    };
  }

  export const GetInvoicesEndpoint = "/grpc/orgs.Orgs/GetInvoices";
  export function GetInvoices(sender: (req: OrgOrUmbrellaID, endpoint: string) => Promise<InvoiceResponse>, req: OrgOrUmbrellaID): { promise: () => Promise<InvoiceResponse>, endpoint: string } {
    return {
      promise: () => sender(req, GetInvoicesEndpoint),
      endpoint: GetInvoicesEndpoint
    };
  }

  export const GetInvoiceEndpoint = "/grpc/orgs.Orgs/GetInvoice";
  export function GetInvoice(sender: (req: GetInvoiceRequest, endpoint: string) => Promise<Invoice>, req: GetInvoiceRequest): { promise: () => Promise<Invoice>, endpoint: string } {
    return {
      promise: () => sender(req, GetInvoiceEndpoint),
      endpoint: GetInvoiceEndpoint
    };
  }

  export const FreemiumSubscribeEndpoint = "/grpc/orgs.Orgs/FreemiumSubscribe";
  /** Subscribe to freemium */
  export function FreemiumSubscribe(sender: (req: FreemiumSubscribeRequest, endpoint: string) => Promise<{}>, req: FreemiumSubscribeRequest): { promise: () => Promise<{}>, endpoint: string } {
    return {
      promise: () => sender(req, FreemiumSubscribeEndpoint),
      endpoint: FreemiumSubscribeEndpoint
    };
  }

  export const UpdatePaymentEndpoint = "/grpc/orgs.Orgs/UpdatePayment";
  /** Set or update credit card info */
  export function UpdatePayment(sender: (req: UpdatePaymentRequest, endpoint: string) => Promise<{}>, req: UpdatePaymentRequest): { promise: () => Promise<{}>, endpoint: string } {
    return {
      promise: () => sender(req, UpdatePaymentEndpoint),
      endpoint: UpdatePaymentEndpoint
    };
  }

  export const UpdateBillingInfoEndpoint = "/grpc/orgs.Orgs/UpdateBillingInfo";
  export function UpdateBillingInfo(sender: (req: UpdateBillingInfoRequest, endpoint: string) => Promise<{}>, req: UpdateBillingInfoRequest): { promise: () => Promise<{}>, endpoint: string } {
    return {
      promise: () => sender(req, UpdateBillingInfoEndpoint),
      endpoint: UpdateBillingInfoEndpoint
    };
  }

  export const UpdateSessionOverageConfigEndpoint = "/grpc/orgs.Orgs/UpdateSessionOverageConfig";
  /** UpdateSessionOverageConfig updates the properties of the SessionOverageConfig of the org/umbrella */
  export function UpdateSessionOverageConfig(sender: (req: UpdateSessionOverageConfigRequest, endpoint: string) => Promise<SessionOverageConfig>, req: UpdateSessionOverageConfigRequest): { promise: () => Promise<SessionOverageConfig>, endpoint: string } {
    return {
      promise: () => sender(req, UpdateSessionOverageConfigEndpoint),
      endpoint: UpdateSessionOverageConfigEndpoint
    };
  }

  export const GetUmbrellaEndpoint = "/grpc/orgs.Orgs/GetUmbrella";
  export function GetUmbrella(sender: (req: GetUmbrellaRequest, endpoint: string) => Promise<Umbrella>, req: GetUmbrellaRequest): { promise: () => Promise<Umbrella>, endpoint: string } {
    return {
      promise: () => sender(req, GetUmbrellaEndpoint),
      endpoint: GetUmbrellaEndpoint
    };
  }

  export const CreateUmbrellaFromOrgEndpoint = "/grpc/orgs.Orgs/CreateUmbrellaFromOrg";
  /**
   * Will immediately create a new Umbrella and put the org under it,
   * Initialized with plan and payment data from the org.
   */
  export function CreateUmbrellaFromOrg(sender: (req: CreateUmbrellaFromOrgRequest, endpoint: string) => Promise<UmbrellaID>, req: CreateUmbrellaFromOrgRequest): { promise: () => Promise<UmbrellaID>, endpoint: string } {
    return {
      promise: () => sender(req, CreateUmbrellaFromOrgEndpoint),
      endpoint: CreateUmbrellaFromOrgEndpoint
    };
  }

  export const AddNewOrgToUmbrellaEndpoint = "/grpc/orgs.Orgs/AddNewOrgToUmbrella";
  /** Create a new org and attach it to this Umbrella. */
  export function AddNewOrgToUmbrella(sender: (req: AddNewOrgToUmbrellaRequest, endpoint: string) => Promise<AddNewOrgToUmbrellaResponse>, req: AddNewOrgToUmbrellaRequest): { promise: () => Promise<AddNewOrgToUmbrellaResponse>, endpoint: string } {
    return {
      promise: () => sender(req, AddNewOrgToUmbrellaEndpoint),
      endpoint: AddNewOrgToUmbrellaEndpoint
    };
  }

  export const CancelUmbrellaOrgsEndpoint = "/grpc/orgs.Orgs/CancelUmbrellaOrgs";
  export function CancelUmbrellaOrgs(sender: (req: CancelUmbrellaOrgsRequest, endpoint: string) => Promise<{}>, req: CancelUmbrellaOrgsRequest): { promise: () => Promise<{}>, endpoint: string } {
    return {
      promise: () => sender(req, CancelUmbrellaOrgsEndpoint),
      endpoint: CancelUmbrellaOrgsEndpoint
    };
  }

  export const UpdateUmbrellaMetadataEndpoint = "/grpc/orgs.Orgs/UpdateUmbrellaMetadata";
  export function UpdateUmbrellaMetadata(sender: (req: UpdateUmbrellaMetadataRequest, endpoint: string) => Promise<{}>, req: UpdateUmbrellaMetadataRequest): { promise: () => Promise<{}>, endpoint: string } {
    return {
      promise: () => sender(req, UpdateUmbrellaMetadataEndpoint),
      endpoint: UpdateUmbrellaMetadataEndpoint
    };
  }

  export const UpdateUmbrellaAllocationEndpoint = "/grpc/orgs.Orgs/UpdateUmbrellaAllocation";
  export function UpdateUmbrellaAllocation(sender: (req: UpdateUmbrellaAllocationRequest, endpoint: string) => Promise<UpdateUmbrellaAllocationResponse>, req: UpdateUmbrellaAllocationRequest): { promise: () => Promise<UpdateUmbrellaAllocationResponse>, endpoint: string } {
    return {
      promise: () => sender(req, UpdateUmbrellaAllocationEndpoint),
      endpoint: UpdateUmbrellaAllocationEndpoint
    };
  }

  export const GetSeatEndpoint = "/grpc/orgs.Orgs/GetSeat";
  export function GetSeat(sender: (req: GetSeatRequest, endpoint: string) => Promise<Seat>, req: GetSeatRequest): { promise: () => Promise<Seat>, endpoint: string } {
    return {
      promise: () => sender(req, GetSeatEndpoint),
      endpoint: GetSeatEndpoint
    };
  }

  export const GetSeatsEndpoint = "/grpc/orgs.Orgs/GetSeats";
  export function GetSeats(sender: (req: GetSeatsRequest, endpoint: string) => Promise<SeatsAndInvitesResponse>, req: GetSeatsRequest): { promise: () => Promise<SeatsAndInvitesResponse>, endpoint: string } {
    return {
      promise: () => sender(req, GetSeatsEndpoint),
      endpoint: GetSeatsEndpoint
    };
  }

  export const GetOrgIdsForPersonEndpoint = "/grpc/orgs.Orgs/GetOrgIdsForPerson";
  /**
   * Gets a list of all the orgId's that a person has a seat on.
   * Specifically, we aren't just checking their person entity for the list there, we are querying every org for a seat this person might have.
   */
  export function GetOrgIdsForPerson(sender: (req: GetOrgIdsForPersonRequest, endpoint: string) => Promise<GetOrgIdsForPersonResponse>, req: GetOrgIdsForPersonRequest): { promise: () => Promise<GetOrgIdsForPersonResponse>, endpoint: string } {
    return {
      promise: () => sender(req, GetOrgIdsForPersonEndpoint),
      endpoint: GetOrgIdsForPersonEndpoint
    };
  }

  export const CreateOrgSeatEndpoint = "/grpc/orgs.Orgs/CreateOrgSeat";
  /**
   * CreateOrgSeat will place a new seat under an org. This method is only useful for specific cases where there is no
   * customer communication i.e. partner-managed embed orgs.
   * In the majority of cases you will want users to go through our invite flow in order to obtain a seat on an org.
   */
  export function CreateOrgSeat(sender: (req: CreateOrgSeatRequest, endpoint: string) => Promise<Seat>, req: CreateOrgSeatRequest): { promise: () => Promise<Seat>, endpoint: string } {
    return {
      promise: () => sender(req, CreateOrgSeatEndpoint),
      endpoint: CreateOrgSeatEndpoint
    };
  }

  export const UpsertScimManagedSeatEndpoint = "/grpc/orgs.Orgs/UpsertScimManagedSeat";
  /** UpsertScimManagedSeat is intended to be used by our SCIM service in otto to create seats for users provisioned by customers' IdPs */
  export function UpsertScimManagedSeat(sender: (req: UpsertScimManagedSeatRequest, endpoint: string) => Promise<UpsertScimManagedSeatResponse>, req: UpsertScimManagedSeatRequest): { promise: () => Promise<UpsertScimManagedSeatResponse>, endpoint: string } {
    return {
      promise: () => sender(req, UpsertScimManagedSeatEndpoint),
      endpoint: UpsertScimManagedSeatEndpoint
    };
  }

  export const GetSeatsAndInvitesEndpoint = "/grpc/orgs.Orgs/GetSeatsAndInvites";
  /**
   * GetSeatsAndInvites fetches a list of combined seat & invite entities for a given org/umbrella
   * If fetching for an umbrella, it only returns seats in an umbrella's namespace, which happens to be only
   * Umbrella managers, not every seat/inv on every org in the umbrella.
   */
  export function GetSeatsAndInvites(sender: (req: GetSeatsAndInvitesRequest, endpoint: string) => Promise<GetSeatsAndInvitesResponse>, req: GetSeatsAndInvitesRequest): { promise: () => Promise<GetSeatsAndInvitesResponse>, endpoint: string } {
    return {
      promise: () => sender(req, GetSeatsAndInvitesEndpoint),
      endpoint: GetSeatsAndInvitesEndpoint
    };
  }

  export const GetSeatsAndInvitesForUmbrellaEndpoint = "/grpc/orgs.Orgs/GetSeatsAndInvitesForUmbrella";
  /** GetSeatsAndInvitesForUmbrella fetches a list of users and all the seats & invites they have on an umbrella */
  export function GetSeatsAndInvitesForUmbrella(sender: (req: GetSeatsAndInvitesForUmbrellaRequest, endpoint: string) => Promise<GetSeatsAndInvitesForUmbrellaResponse>, req: GetSeatsAndInvitesForUmbrellaRequest): { promise: () => Promise<GetSeatsAndInvitesForUmbrellaResponse>, endpoint: string } {
    return {
      promise: () => sender(req, GetSeatsAndInvitesForUmbrellaEndpoint),
      endpoint: GetSeatsAndInvitesForUmbrellaEndpoint
    };
  }

  export const GetInviteEndpoint = "/grpc/orgs.Orgs/GetInvite";
  export function GetInvite(sender: (req: SeatID, endpoint: string) => Promise<Invite>, req: SeatID): { promise: () => Promise<Invite>, endpoint: string } {
    return {
      promise: () => sender(req, GetInviteEndpoint),
      endpoint: GetInviteEndpoint
    };
  }

  export const CreateInviteEndpoint = "/grpc/orgs.Orgs/CreateInvite";
  export function CreateInvite(sender: (req: CreateInviteRequest, endpoint: string) => Promise<CreateInviteResponse>, req: CreateInviteRequest): { promise: () => Promise<CreateInviteResponse>, endpoint: string } {
    return {
      promise: () => sender(req, CreateInviteEndpoint),
      endpoint: CreateInviteEndpoint
    };
  }

  export const BatchCreateInvitesEndpoint = "/grpc/orgs.Orgs/BatchCreateInvites";
  export function BatchCreateInvites(sender: (req: BatchCreateInvitesRequest, endpoint: string) => Promise<BatchCreateInvitesResponse>, req: BatchCreateInvitesRequest): { promise: () => Promise<BatchCreateInvitesResponse>, endpoint: string } {
    return {
      promise: () => sender(req, BatchCreateInvitesEndpoint),
      endpoint: BatchCreateInvitesEndpoint
    };
  }

  export const GetUmbrellaInviteEndpoint = "/grpc/orgs.Orgs/GetUmbrellaInvite";
  export function GetUmbrellaInvite(sender: (req: GetUmbrellaInviteRequest, endpoint: string) => Promise<UmbrellaInvite>, req: GetUmbrellaInviteRequest): { promise: () => Promise<UmbrellaInvite>, endpoint: string } {
    return {
      promise: () => sender(req, GetUmbrellaInviteEndpoint),
      endpoint: GetUmbrellaInviteEndpoint
    };
  }

  export const CreateUmbrellaInviteEndpoint = "/grpc/orgs.Orgs/CreateUmbrellaInvite";
  export function CreateUmbrellaInvite(sender: (req: CreateUmbrellaInviteRequest, endpoint: string) => Promise<CreateUmbrellaInviteResponse>, req: CreateUmbrellaInviteRequest): { promise: () => Promise<CreateUmbrellaInviteResponse>, endpoint: string } {
    return {
      promise: () => sender(req, CreateUmbrellaInviteEndpoint),
      endpoint: CreateUmbrellaInviteEndpoint
    };
  }

  export const RevokeInviteEndpoint = "/grpc/orgs.Orgs/RevokeInvite";
  export function RevokeInvite(sender: (req: RevokeInviteRequest, endpoint: string) => Promise<{}>, req: RevokeInviteRequest): { promise: () => Promise<{}>, endpoint: string } {
    return {
      promise: () => sender(req, RevokeInviteEndpoint),
      endpoint: RevokeInviteEndpoint
    };
  }

  export const RevokeUmbrellaInviteEndpoint = "/grpc/orgs.Orgs/RevokeUmbrellaInvite";
  export function RevokeUmbrellaInvite(sender: (req: RevokeUmbrellaInviteRequest, endpoint: string) => Promise<{}>, req: RevokeUmbrellaInviteRequest): { promise: () => Promise<{}>, endpoint: string } {
    return {
      promise: () => sender(req, RevokeUmbrellaInviteEndpoint),
      endpoint: RevokeUmbrellaInviteEndpoint
    };
  }

  export const GetActiveOrgSeatForPersonEndpoint = "/grpc/orgs.Orgs/GetActiveOrgSeatForPerson";
  /** Get any seat a person has access to that is not view-only */
  export function GetActiveOrgSeatForPerson(sender: (req: GetActiveOrgSeatForPersonRequest, endpoint: string) => Promise<GetActiveOrgSeatForPersonResponse>, req: GetActiveOrgSeatForPersonRequest): { promise: () => Promise<GetActiveOrgSeatForPersonResponse>, endpoint: string } {
    return {
      promise: () => sender(req, GetActiveOrgSeatForPersonEndpoint),
      endpoint: GetActiveOrgSeatForPersonEndpoint
    };
  }

  export const UpdateSeatsForPersonInUmbrellaEndpoint = "/grpc/orgs.Orgs/UpdateSeatsForPersonInUmbrella";
  /**
   * Update seats for a person across multiple orgs in one umbrella. Does not support making the person a UM.
   * ALWAYS check not_enough_seats and server_error for partial failures! Some requested updates may fail and no error returned!
   */
  export function UpdateSeatsForPersonInUmbrella(sender: (req: UpdateSeatsForPersonInUmbrellaRequest, endpoint: string) => Promise<UpdateSeatsForPersonInUmbrellaResponse>, req: UpdateSeatsForPersonInUmbrellaRequest): { promise: () => Promise<UpdateSeatsForPersonInUmbrellaResponse>, endpoint: string } {
    return {
      promise: () => sender(req, UpdateSeatsForPersonInUmbrellaEndpoint),
      endpoint: UpdateSeatsForPersonInUmbrellaEndpoint
    };
  }

  export const ChangeRoleToUmbrellaManagerEndpoint = "/grpc/orgs.Orgs/ChangeRoleToUmbrellaManager";
  /** Change an existing person to an umbrella manager */
  export function ChangeRoleToUmbrellaManager(sender: (req: ChangeRoleToUmbrellaManagerRequest, endpoint: string) => Promise<{}>, req: ChangeRoleToUmbrellaManagerRequest): { promise: () => Promise<{}>, endpoint: string } {
    return {
      promise: () => sender(req, ChangeRoleToUmbrellaManagerEndpoint),
      endpoint: ChangeRoleToUmbrellaManagerEndpoint
    };
  }

  export const UpdateScimManagedSeatEndpoint = "/grpc/orgs.Orgs/UpdateScimManagedSeat";
  /** UpdateScimManagedSeat is intended to be used by our SCIM service in otto to update seats using profile data from a customers' IdPs */
  export function UpdateScimManagedSeat(sender: (req: UpdateScimManagedSeatRequest, endpoint: string) => Promise<{}>, req: UpdateScimManagedSeatRequest): { promise: () => Promise<{}>, endpoint: string } {
    return {
      promise: () => sender(req, UpdateScimManagedSeatEndpoint),
      endpoint: UpdateScimManagedSeatEndpoint
    };
  }

  export const UpdateSeatForPersonInOrgEndpoint = "/grpc/orgs.Orgs/UpdateSeatForPersonInOrg";
  export function UpdateSeatForPersonInOrg(sender: (req: UpdateSeatForPersonRequest, endpoint: string) => Promise<UpdateSeatForPersonResponse>, req: UpdateSeatForPersonRequest): { promise: () => Promise<UpdateSeatForPersonResponse>, endpoint: string } {
    return {
      promise: () => sender(req, UpdateSeatForPersonInOrgEndpoint),
      endpoint: UpdateSeatForPersonInOrgEndpoint
    };
  }

  export const UpdateSeatLastActivityEndpoint = "/grpc/orgs.Orgs/UpdateSeatLastActivity";
  export function UpdateSeatLastActivity(sender: (req: UpdateSeatLastActivityRequest, endpoint: string) => Promise<{}>, req: UpdateSeatLastActivityRequest): { promise: () => Promise<{}>, endpoint: string } {
    return {
      promise: () => sender(req, UpdateSeatLastActivityEndpoint),
      endpoint: UpdateSeatLastActivityEndpoint
    };
  }

  export const UpdateSeatDisabledEndpoint = "/grpc/orgs.Orgs/UpdateSeatDisabled";
  export function UpdateSeatDisabled(sender: (req: UpdateSeatDisabledRequest, endpoint: string) => Promise<{}>, req: UpdateSeatDisabledRequest): { promise: () => Promise<{}>, endpoint: string } {
    return {
      promise: () => sender(req, UpdateSeatDisabledEndpoint),
      endpoint: UpdateSeatDisabledEndpoint
    };
  }

  export const UpdateSeatsDisabledEndpoint = "/grpc/orgs.Orgs/UpdateSeatsDisabled";
  /**
   * Deprecated: Switch to using BatchUpdateOrgSeats
   * TODO(harris): Replace calls to this method with BatchUpdateOrgSeats and remove
   */
  export function UpdateSeatsDisabled(sender: (req: UpdateSeatsDisabledRequest, endpoint: string) => Promise<{}>, req: UpdateSeatsDisabledRequest): { promise: () => Promise<{}>, endpoint: string } {
    return {
      promise: () => sender(req, UpdateSeatsDisabledEndpoint),
      endpoint: UpdateSeatsDisabledEndpoint
    };
  }

  export const BatchUpdateOrgSeatsEndpoint = "/grpc/orgs.Orgs/BatchUpdateOrgSeats";
  /** BatchUpdateOrgSeats will update fields on all provided seats, for the given org. */
  export function BatchUpdateOrgSeats(sender: (req: BatchUpdateOrgSeatsRequest, endpoint: string) => Promise<BatchUpdateOrgSeatsResponse>, req: BatchUpdateOrgSeatsRequest): { promise: () => Promise<BatchUpdateOrgSeatsResponse>, endpoint: string } {
    return {
      promise: () => sender(req, BatchUpdateOrgSeatsEndpoint),
      endpoint: BatchUpdateOrgSeatsEndpoint
    };
  }

  export const GetOrgUsedSeatCountEndpoint = "/grpc/orgs.Orgs/GetOrgUsedSeatCount";
  /**
   * GetOrgUsedSeatCount will compute how many seats have been used on a given org. Basically, the total of
   * non-guest seats and outstanding invites.
   */
  export function GetOrgUsedSeatCount(sender: (req: GetOrgUsedSeatCountRequest, endpoint: string) => Promise<GetOrgUsedSeatCountResponse>, req: GetOrgUsedSeatCountRequest): { promise: () => Promise<GetOrgUsedSeatCountResponse>, endpoint: string } {
    return {
      promise: () => sender(req, GetOrgUsedSeatCountEndpoint),
      endpoint: GetOrgUsedSeatCountEndpoint
    };
  }

  export const UpdateRequiresDeviceVerificationEndpoint = "/grpc/orgs.Orgs/UpdateRequiresDeviceVerification";
  /** Update whether device verification is required for logins */
  export function UpdateRequiresDeviceVerification(sender: (req: UpdateRequiresDeviceVerificationRequest, endpoint: string) => Promise<{}>, req: UpdateRequiresDeviceVerificationRequest): { promise: () => Promise<{}>, endpoint: string } {
    return {
      promise: () => sender(req, UpdateRequiresDeviceVerificationEndpoint),
      endpoint: UpdateRequiresDeviceVerificationEndpoint
    };
  }

  export const UpdateAuthSettingsEndpoint = "/grpc/orgs.Orgs/UpdateAuthSettings";
  /**
   * Update whether the users for an org will have to authenticate via Google or Auth0. Can also reset the
   * authentication method to the FullStory default of email & password.
   */
  export function UpdateAuthSettings(sender: (req: UpdateAuthSettingsRequest, endpoint: string) => Promise<{}>, req: UpdateAuthSettingsRequest): { promise: () => Promise<{}>, endpoint: string } {
    return {
      promise: () => sender(req, UpdateAuthSettingsEndpoint),
      endpoint: UpdateAuthSettingsEndpoint
    };
  }

  export const GetDefaultFlagsEndpoint = "/grpc/orgs.Orgs/GetDefaultFlags";
  export function GetDefaultFlags(sender: (req: {}, endpoint: string) => Promise<flags.FlagsProto>, req: {}): { promise: () => Promise<flags.FlagsProto>, endpoint: string } {
    return {
      promise: () => sender(req, GetDefaultFlagsEndpoint),
      endpoint: GetDefaultFlagsEndpoint
    };
  }

  export const GetTeamsForDomainEndpoint = "/grpc/orgs.Orgs/GetTeamsForDomain";
  /**
   * For a given email domain, fetch all associated SSO connection team names
   * Note: This endpoint is going to be called from the login page which is why
   * we don't want to gate it with any permission flags.
   */
  export function GetTeamsForDomain(sender: (req: GetTeamsForDomainRequest, endpoint: string) => Promise<GetTeamsForDomainResponse>, req: GetTeamsForDomainRequest): { promise: () => Promise<GetTeamsForDomainResponse>, endpoint: string } {
    return {
      promise: () => sender(req, GetTeamsForDomainEndpoint),
      endpoint: GetTeamsForDomainEndpoint
    };
  }

  export const GetOrgsForTeamEndpoint = "/grpc/orgs.Orgs/GetOrgsForTeam";
  export function GetOrgsForTeam(sender: (req: GetOrgsForTeamRequest, endpoint: string) => Promise<GetOrgsForTeamResponse>, req: GetOrgsForTeamRequest): { promise: () => Promise<GetOrgsForTeamResponse>, endpoint: string } {
    return {
      promise: () => sender(req, GetOrgsForTeamEndpoint),
      endpoint: GetOrgsForTeamEndpoint
    };
  }

  export const GetAuthDomainsForOrgEndpoint = "/grpc/orgs.Orgs/GetAuthDomainsForOrg";
  export function GetAuthDomainsForOrg(sender: (req: OrgID, endpoint: string) => Promise<GetAuthDomainsForOrgResponse>, req: OrgID): { promise: () => Promise<GetAuthDomainsForOrgResponse>, endpoint: string } {
    return {
      promise: () => sender(req, GetAuthDomainsForOrgEndpoint),
      endpoint: GetAuthDomainsForOrgEndpoint
    };
  }

  export const UpdateSsoConfigEndpoint = "/grpc/orgs.Orgs/UpdateSsoConfig";
  /** UpdateSsoConfig will updates to the SSO configuration for an org */
  export function UpdateSsoConfig(sender: (req: UpdateSsoConfigRequest, endpoint: string) => Promise<UpdateSsoConfigResponse>, req: UpdateSsoConfigRequest): { promise: () => Promise<UpdateSsoConfigResponse>, endpoint: string } {
    return {
      promise: () => sender(req, UpdateSsoConfigEndpoint),
      endpoint: UpdateSsoConfigEndpoint
    };
  }

  export const GetSsoAutoProvisionOrgsEndpoint = "/grpc/orgs.Orgs/GetSsoAutoProvisionOrgs";
  /** GetSsoAutoProvisionOrgs fetches all auto/JIT provisionable orgs associated with a given SSO team name. */
  export function GetSsoAutoProvisionOrgs(sender: (req: GetSsoAutoProvisionOrgsRequest, endpoint: string) => Promise<GetSsoAutoProvisionOrgsResponse>, req: GetSsoAutoProvisionOrgsRequest): { promise: () => Promise<GetSsoAutoProvisionOrgsResponse>, endpoint: string } {
    return {
      promise: () => sender(req, GetSsoAutoProvisionOrgsEndpoint),
      endpoint: GetSsoAutoProvisionOrgsEndpoint
    };
  }
}

/** TODO(stephanie): Move to a proper billing service. */
export namespace BillingServicePublic {

  export const CancelEndpoint = "/grpc/orgs.BillingServicePublic/Cancel";
  /** Cancel subscription */
  export function Cancel(sender: (req: OrgOrUmbrellaID, endpoint: string) => Promise<CancelResponse>, req: OrgOrUmbrellaID): { promise: () => Promise<CancelResponse>, endpoint: string } {
    return {
      promise: () => sender(req, CancelEndpoint),
      endpoint: CancelEndpoint
    };
  }

  export const GetInvoicesEndpoint = "/grpc/orgs.BillingServicePublic/GetInvoices";
  /** Fetch stripe invoices */
  export function GetInvoices(sender: (req: OrgOrUmbrellaID, endpoint: string) => Promise<InvoiceResponse>, req: OrgOrUmbrellaID): { promise: () => Promise<InvoiceResponse>, endpoint: string } {
    return {
      promise: () => sender(req, GetInvoicesEndpoint),
      endpoint: GetInvoicesEndpoint
    };
  }
}

export namespace Cron {

  export const UpdateOrgEndpoint = "/grpc/orgs.Cron/UpdateOrg";
  /** Check the orgs state/quota period and update if necessary */
  export function UpdateOrg(sender: (req: OrgID, endpoint: string) => Promise<{}>, req: OrgID): { promise: () => Promise<{}>, endpoint: string } {
    return {
      promise: () => sender(req, UpdateOrgEndpoint),
      endpoint: UpdateOrgEndpoint
    };
  }
}

/**
 * ////////////////////////////////////
 * Contacts management
 * ////////////////////////////////////
 */
export namespace OrgsServicePublic {

  export const GetContactsEndpoint = "/grpc/orgs.OrgsServicePublic/GetContacts";
  /** GetContacts returns the emails for all contact types for the given org/umbrella ID. */
  export function GetContacts(sender: (req: GetContactsRequest, endpoint: string) => Promise<GetContactsResponse>, req: GetContactsRequest): { promise: () => Promise<GetContactsResponse>, endpoint: string } {
    return {
      promise: () => sender(req, GetContactsEndpoint),
      endpoint: GetContactsEndpoint
    };
  }

  export const UpdateContactsEndpoint = "/grpc/orgs.OrgsServicePublic/UpdateContacts";
  /** UpdateContacts updates the emails for the given contact types, for the input org/umbrella ID. */
  export function UpdateContacts(sender: (req: UpdateContactsRequest, endpoint: string) => Promise<{}>, req: UpdateContactsRequest): { promise: () => Promise<{}>, endpoint: string } {
    return {
      promise: () => sender(req, UpdateContactsEndpoint),
      endpoint: UpdateContactsEndpoint
    };
  }

  export const BatchRevokeInvitesEndpoint = "/grpc/orgs.OrgsServicePublic/BatchRevokeInvites";
  /** BatchRevokeInvites will revoke all invites to the email addresses provided */
  export function BatchRevokeInvites(sender: (req: BatchRevokeInvitesRequest, endpoint: string) => Promise<{}>, req: BatchRevokeInvitesRequest): { promise: () => Promise<{}>, endpoint: string } {
    return {
      promise: () => sender(req, BatchRevokeInvitesEndpoint),
      endpoint: BatchRevokeInvitesEndpoint
    };
  }

  export const BatchDeleteSeatsEndpoint = "/grpc/orgs.OrgsServicePublic/BatchDeleteSeats";
  /** BatchDeleteSeats will delete all the seats associated with the provided email addresses, for the given org. */
  export function BatchDeleteSeats(sender: (req: BatchDeleteSeatsRequest, endpoint: string) => Promise<{}>, req: BatchDeleteSeatsRequest): { promise: () => Promise<{}>, endpoint: string } {
    return {
      promise: () => sender(req, BatchDeleteSeatsEndpoint),
      endpoint: BatchDeleteSeatsEndpoint
    };
  }

  export const GetSeatEndpoint = "/grpc/orgs.OrgsServicePublic/GetSeat";
  export function GetSeat(sender: (req: GetSeatRequest, endpoint: string) => Promise<Seat>, req: GetSeatRequest): { promise: () => Promise<Seat>, endpoint: string } {
    return {
      promise: () => sender(req, GetSeatEndpoint),
      endpoint: GetSeatEndpoint
    };
  }

  export const GetSeatsAndInvitesEndpoint = "/grpc/orgs.OrgsServicePublic/GetSeatsAndInvites";
  /**
   * GetSeatsAndInvites fetches a list of combined seat & invite entities for a given org/umbrella
   * If fetching for an umbrella, it only returns seats in an umbrella's namespace, which happens to be only
   * Umbrella managers, not every seat/inv on every org in the umbrella.
   */
  export function GetSeatsAndInvites(sender: (req: GetSeatsAndInvitesRequest, endpoint: string) => Promise<GetSeatsAndInvitesResponse>, req: GetSeatsAndInvitesRequest): { promise: () => Promise<GetSeatsAndInvitesResponse>, endpoint: string } {
    return {
      promise: () => sender(req, GetSeatsAndInvitesEndpoint),
      endpoint: GetSeatsAndInvitesEndpoint
    };
  }

  export const GetSeatsAndInvitesForUmbrellaEndpoint = "/grpc/orgs.OrgsServicePublic/GetSeatsAndInvitesForUmbrella";
  /** GetSeatsAndInvitesForUmbrella fetches a list of users and all the seats & invites they have on an umbrella */
  export function GetSeatsAndInvitesForUmbrella(sender: (req: GetSeatsAndInvitesForUmbrellaRequest, endpoint: string) => Promise<GetSeatsAndInvitesForUmbrellaResponse>, req: GetSeatsAndInvitesForUmbrellaRequest): { promise: () => Promise<GetSeatsAndInvitesForUmbrellaResponse>, endpoint: string } {
    return {
      promise: () => sender(req, GetSeatsAndInvitesForUmbrellaEndpoint),
      endpoint: GetSeatsAndInvitesForUmbrellaEndpoint
    };
  }

  export const UpdateSeatDisabledEndpoint = "/grpc/orgs.OrgsServicePublic/UpdateSeatDisabled";
  export function UpdateSeatDisabled(sender: (req: UpdateSeatDisabledRequest, endpoint: string) => Promise<{}>, req: UpdateSeatDisabledRequest): { promise: () => Promise<{}>, endpoint: string } {
    return {
      promise: () => sender(req, UpdateSeatDisabledEndpoint),
      endpoint: UpdateSeatDisabledEndpoint
    };
  }

  export const UpdateJoinOrgSettingsEndpoint = "/grpc/orgs.OrgsServicePublic/UpdateJoinOrgSettings";
  /** Update settings around allowing users to request to join the org */
  export function UpdateJoinOrgSettings(sender: (req: UpdateJoinSettingsRequest, endpoint: string) => Promise<UpdateJoinSettingsResponse>, req: UpdateJoinSettingsRequest): { promise: () => Promise<UpdateJoinSettingsResponse>, endpoint: string } {
    return {
      promise: () => sender(req, UpdateJoinOrgSettingsEndpoint),
      endpoint: UpdateJoinOrgSettingsEndpoint
    };
  }

  export const BatchUpdateUsersInUmbrellaEndpoint = "/grpc/orgs.OrgsServicePublic/BatchUpdateUsersInUmbrella";
  /** Removes, enables, or disables all of the selected users from all orgs in the selected umbrella */
  export function BatchUpdateUsersInUmbrella(sender: (req: BatchUpdateUsersInUmbrellaRequest, endpoint: string) => Promise<{}>, req: BatchUpdateUsersInUmbrellaRequest): { promise: () => Promise<{}>, endpoint: string } {
    return {
      promise: () => sender(req, BatchUpdateUsersInUmbrellaEndpoint),
      endpoint: BatchUpdateUsersInUmbrellaEndpoint
    };
  }

  export const RevokeUmbrellaInviteEndpoint = "/grpc/orgs.OrgsServicePublic/RevokeUmbrellaInvite";
  export function RevokeUmbrellaInvite(sender: (req: RevokeUmbrellaInviteRequest, endpoint: string) => Promise<{}>, req: RevokeUmbrellaInviteRequest): { promise: () => Promise<{}>, endpoint: string } {
    return {
      promise: () => sender(req, RevokeUmbrellaInviteEndpoint),
      endpoint: RevokeUmbrellaInviteEndpoint
    };
  }

  export const ComputePreSsoConnectionInfoEndpoint = "/grpc/orgs.OrgsServicePublic/ComputePreSsoConnectionInfo";
  /**
   * ComputePreSsoConnectionInfo will compute all of the information that a FullStory admin will need to FullStory
   * SSO into their current identity provider (IdP).
   */
  export function ComputePreSsoConnectionInfo(sender: (req: ComputePreSsoConnectionInfoRequest, endpoint: string) => Promise<ComputePreSsoConnectionInfoResponse>, req: ComputePreSsoConnectionInfoRequest): { promise: () => Promise<ComputePreSsoConnectionInfoResponse>, endpoint: string } {
    return {
      promise: () => sender(req, ComputePreSsoConnectionInfoEndpoint),
      endpoint: ComputePreSsoConnectionInfoEndpoint
    };
  }

  export const ProvisionSsoEndpoint = "/grpc/orgs.OrgsServicePublic/ProvisionSso";
  /**
   * ProvisionSSO will create an SSO connection in FullStory that users for the org will be able to use to route
   * through their IdP and log into FSTA.
   */
  export function ProvisionSso(sender: (req: ProvisionSsoRequest, endpoint: string) => Promise<SsoSettings>, req: ProvisionSsoRequest): { promise: () => Promise<SsoSettings>, endpoint: string } {
    return {
      promise: () => sender(req, ProvisionSsoEndpoint),
      endpoint: ProvisionSsoEndpoint
    };
  }

  export const GetSsoSettingsEndpoint = "/grpc/orgs.OrgsServicePublic/GetSsoSettings";
  /** GetSsoSettings will fetch the current SSO configuration for the org. */
  export function GetSsoSettings(sender: (req: GetSsoSettingsRequest, endpoint: string) => Promise<SsoSettings>, req: GetSsoSettingsRequest): { promise: () => Promise<SsoSettings>, endpoint: string } {
    return {
      promise: () => sender(req, GetSsoSettingsEndpoint),
      endpoint: GetSsoSettingsEndpoint
    };
  }

  export const UpdateSsoConfigEndpoint = "/grpc/orgs.OrgsServicePublic/UpdateSsoConfig";
  /** UpdateSsoConfig will updates to the SSO configuration for an org */
  export function UpdateSsoConfig(sender: (req: UpdateSsoConfigRequest, endpoint: string) => Promise<UpdateSsoConfigResponse>, req: UpdateSsoConfigRequest): { promise: () => Promise<UpdateSsoConfigResponse>, endpoint: string } {
    return {
      promise: () => sender(req, UpdateSsoConfigEndpoint),
      endpoint: UpdateSsoConfigEndpoint
    };
  }

  export const DeprovisionSsoEndpoint = "/grpc/orgs.OrgsServicePublic/DeprovisionSso";
  /** DeprovisionSSO will remove the SSO connection on the FullStory side and clean up any associated metadata. */
  export function DeprovisionSso(sender: (req: DeprovisionSsoRequest, endpoint: string) => Promise<{}>, req: DeprovisionSsoRequest): { promise: () => Promise<{}>, endpoint: string } {
    return {
      promise: () => sender(req, DeprovisionSsoEndpoint),
      endpoint: DeprovisionSsoEndpoint
    };
  }

  export const AddTeamDomainEndpoint = "/grpc/orgs.OrgsServicePublic/AddTeamDomain";
  /** Upsert a SSO Team + Email Domain association into the system */
  export function AddTeamDomain(sender: (req: AddTeamDomainRequest, endpoint: string) => Promise<{}>, req: AddTeamDomainRequest): { promise: () => Promise<{}>, endpoint: string } {
    return {
      promise: () => sender(req, AddTeamDomainEndpoint),
      endpoint: AddTeamDomainEndpoint
    };
  }

  export const RemoveTeamDomainEndpoint = "/grpc/orgs.OrgsServicePublic/RemoveTeamDomain";
  /** Remove a SSO Team + Email Domain association from the system */
  export function RemoveTeamDomain(sender: (req: RemoveTeamDomainRequest, endpoint: string) => Promise<{}>, req: RemoveTeamDomainRequest): { promise: () => Promise<{}>, endpoint: string } {
    return {
      promise: () => sender(req, RemoveTeamDomainEndpoint),
      endpoint: RemoveTeamDomainEndpoint
    };
  }

  export const GenerateScimApiTokenEndpoint = "/grpc/orgs.OrgsServicePublic/GenerateScimApiToken";
  export function GenerateScimApiToken(sender: (req: GenerateScimApiTokenRequest, endpoint: string) => Promise<GenerateScimApiTokenResponse>, req: GenerateScimApiTokenRequest): { promise: () => Promise<GenerateScimApiTokenResponse>, endpoint: string } {
    return {
      promise: () => sender(req, GenerateScimApiTokenEndpoint),
      endpoint: GenerateScimApiTokenEndpoint
    };
  }

  export const GetScimApiTokenMetadataEndpoint = "/grpc/orgs.OrgsServicePublic/GetScimApiTokenMetadata";
  export function GetScimApiTokenMetadata(sender: (req: GetScimApiTokenMetadataRequest, endpoint: string) => Promise<GetScimApiTokenMetadataResponse>, req: GetScimApiTokenMetadataRequest): { promise: () => Promise<GetScimApiTokenMetadataResponse>, endpoint: string } {
    return {
      promise: () => sender(req, GetScimApiTokenMetadataEndpoint),
      endpoint: GetScimApiTokenMetadataEndpoint
    };
  }

  export const GetScimApiEnabledEndpoint = "/grpc/orgs.OrgsServicePublic/GetScimApiEnabled";
  export function GetScimApiEnabled(sender: (req: GetScimApiEnabledRequest, endpoint: string) => Promise<GetScimApiEnabledResponse>, req: GetScimApiEnabledRequest): { promise: () => Promise<GetScimApiEnabledResponse>, endpoint: string } {
    return {
      promise: () => sender(req, GetScimApiEnabledEndpoint),
      endpoint: GetScimApiEnabledEndpoint
    };
  }

  export const GetScimApiEnabledForUmbrellaEndpoint = "/grpc/orgs.OrgsServicePublic/GetScimApiEnabledForUmbrella";
  export function GetScimApiEnabledForUmbrella(sender: (req: GetScimApiEnabledForUmbrellaRequest, endpoint: string) => Promise<GetScimApiEnabledForUmbrellaResponse>, req: GetScimApiEnabledForUmbrellaRequest): { promise: () => Promise<GetScimApiEnabledForUmbrellaResponse>, endpoint: string } {
    return {
      promise: () => sender(req, GetScimApiEnabledForUmbrellaEndpoint),
      endpoint: GetScimApiEnabledForUmbrellaEndpoint
    };
  }

  export const GetDataExportSettingsEndpoint = "/grpc/orgs.OrgsServicePublic/GetDataExportSettings";
  export function GetDataExportSettings(sender: (req: GetDataExportSettingsRequest, endpoint: string) => Promise<GetDataExportSettingsResponse>, req: GetDataExportSettingsRequest): { promise: () => Promise<GetDataExportSettingsResponse>, endpoint: string } {
    return {
      promise: () => sender(req, GetDataExportSettingsEndpoint),
      endpoint: GetDataExportSettingsEndpoint
    };
  }

  export const UpdateDataExportSettingsEndpoint = "/grpc/orgs.OrgsServicePublic/UpdateDataExportSettings";
  export function UpdateDataExportSettings(sender: (req: UpdateDataExportRequest, endpoint: string) => Promise<{}>, req: UpdateDataExportRequest): { promise: () => Promise<{}>, endpoint: string } {
    return {
      promise: () => sender(req, UpdateDataExportSettingsEndpoint),
      endpoint: UpdateDataExportSettingsEndpoint
    };
  }

  export const FreemiumSubscribeEndpoint = "/grpc/orgs.OrgsServicePublic/FreemiumSubscribe";
  /** Subscribe to freemium */
  export function FreemiumSubscribe(sender: (req: FreemiumSubscribeRequest, endpoint: string) => Promise<{}>, req: FreemiumSubscribeRequest): { promise: () => Promise<{}>, endpoint: string } {
    return {
      promise: () => sender(req, FreemiumSubscribeEndpoint),
      endpoint: FreemiumSubscribeEndpoint
    };
  }

  export const GetSessionOverageConfigEndpoint = "/grpc/orgs.OrgsServicePublic/GetSessionOverageConfig";
  /** GetSessionOverageConfig returns the SessionOverageConfig on the org/umbrella */
  export function GetSessionOverageConfig(sender: (req: OrgOrUmbrellaID, endpoint: string) => Promise<SessionOverageConfig>, req: OrgOrUmbrellaID): { promise: () => Promise<SessionOverageConfig>, endpoint: string } {
    return {
      promise: () => sender(req, GetSessionOverageConfigEndpoint),
      endpoint: GetSessionOverageConfigEndpoint
    };
  }

  export const UpdateSessionOverageConfigEndpoint = "/grpc/orgs.OrgsServicePublic/UpdateSessionOverageConfig";
  /** UpdateSessionOverageConfig updates the properties of the SessionOverageConfig of the org/umbrella */
  export function UpdateSessionOverageConfig(sender: (req: UpdateSessionOverageConfigRequest, endpoint: string) => Promise<SessionOverageConfig>, req: UpdateSessionOverageConfigRequest): { promise: () => Promise<SessionOverageConfig>, endpoint: string } {
    return {
      promise: () => sender(req, UpdateSessionOverageConfigEndpoint),
      endpoint: UpdateSessionOverageConfigEndpoint
    };
  }

  export const GetNotificationConfigEndpoint = "/grpc/orgs.OrgsServicePublic/GetNotificationConfig";
  /** GetNotificationConfig returns the quota NotificationConfig on the org */
  export function GetNotificationConfig(sender: (req: OrgID, endpoint: string) => Promise<NotificationConfig>, req: OrgID): { promise: () => Promise<NotificationConfig>, endpoint: string } {
    return {
      promise: () => sender(req, GetNotificationConfigEndpoint),
      endpoint: GetNotificationConfigEndpoint
    };
  }

  export const UpdateNotificationConfigEndpoint = "/grpc/orgs.OrgsServicePublic/UpdateNotificationConfig";
  /** UpdateNotificationConfig updates the properties of the NotificationConfig for an org */
  export function UpdateNotificationConfig(sender: (req: UpdateNotificationConfigRequest, endpoint: string) => Promise<NotificationConfig>, req: UpdateNotificationConfigRequest): { promise: () => Promise<NotificationConfig>, endpoint: string } {
    return {
      promise: () => sender(req, UpdateNotificationConfigEndpoint),
      endpoint: UpdateNotificationConfigEndpoint
    };
  }

  export const AnalyzeQuotaEndpoint = "/grpc/orgs.OrgsServicePublic/AnalyzeQuota";
  /** AnalyzeQuota gathers and calculates the session usage data displayed on the session management page in settings. */
  export function AnalyzeQuota(sender: (req: AnalyzeQuotaRequest, endpoint: string) => Promise<AnalyzeQuotaResponse>, req: AnalyzeQuotaRequest): { promise: () => Promise<AnalyzeQuotaResponse>, endpoint: string } {
    return {
      promise: () => sender(req, AnalyzeQuotaEndpoint),
      endpoint: AnalyzeQuotaEndpoint
    };
  }

  export const GetCustomSeatRequestConfigEndpoint = "/grpc/orgs.OrgsServicePublic/GetCustomSeatRequestConfig";
  /** GetCustomSeatRequestConfig returns the CustomSeatRequestConfig on the org */
  export function GetCustomSeatRequestConfig(sender: (req: OrgID, endpoint: string) => Promise<CustomSeatRequestConfig>, req: OrgID): { promise: () => Promise<CustomSeatRequestConfig>, endpoint: string } {
    return {
      promise: () => sender(req, GetCustomSeatRequestConfigEndpoint),
      endpoint: GetCustomSeatRequestConfigEndpoint
    };
  }

  export const UpdateCustomSeatRequestConfigEndpoint = "/grpc/orgs.OrgsServicePublic/UpdateCustomSeatRequestConfig";
  /** UpdateCustomSeatRequestConfig updates the properties of the CustomSeatRequestConfig for an org */
  export function UpdateCustomSeatRequestConfig(sender: (req: UpdateCustomSeatRequestConfigRequest, endpoint: string) => Promise<CustomSeatRequestConfig>, req: UpdateCustomSeatRequestConfigRequest): { promise: () => Promise<CustomSeatRequestConfig>, endpoint: string } {
    return {
      promise: () => sender(req, UpdateCustomSeatRequestConfigEndpoint),
      endpoint: UpdateCustomSeatRequestConfigEndpoint
    };
  }
}

/**
 * ExperimentConfigServicePublic is a service for managing experiment settings. These are distinct from launchdarkly
 * flags in that a FSTA admin can set and view settings for their org
 */
export namespace ExperimentConfigServicePublic {

  export const SetExperimentOptedOutEndpoint = "/grpc/orgs.ExperimentConfigServicePublic/SetExperimentOptedOut";
  export function SetExperimentOptedOut(sender: (req: SetExperimentOptedOutRequest, endpoint: string) => Promise<{}>, req: SetExperimentOptedOutRequest): { promise: () => Promise<{}>, endpoint: string } {
    return {
      promise: () => sender(req, SetExperimentOptedOutEndpoint),
      endpoint: SetExperimentOptedOutEndpoint
    };
  }

  export const GetExperimentOptedOutEndpoint = "/grpc/orgs.ExperimentConfigServicePublic/GetExperimentOptedOut";
  export function GetExperimentOptedOut(sender: (req: GetExperimentOptedOutRequest, endpoint: string) => Promise<GetExperimentOptedOutResponse>, req: GetExperimentOptedOutRequest): { promise: () => Promise<GetExperimentOptedOutResponse>, endpoint: string } {
    return {
      promise: () => sender(req, GetExperimentOptedOutEndpoint),
      endpoint: GetExperimentOptedOutEndpoint
    };
  }

  export const GetAllExperimentsOptedOutEndpoint = "/grpc/orgs.ExperimentConfigServicePublic/GetAllExperimentsOptedOut";
  export function GetAllExperimentsOptedOut(sender: (req: GetAllExperimentsOptedOutRequest, endpoint: string) => Promise<GetAllExperimentsOptedOutResponse>, req: GetAllExperimentsOptedOutRequest): { promise: () => Promise<GetAllExperimentsOptedOutResponse>, endpoint: string } {
    return {
      promise: () => sender(req, GetAllExperimentsOptedOutEndpoint),
      endpoint: GetAllExperimentsOptedOutEndpoint
    };
  }
}

export interface BatchEvaluateFlagsRequest {
  orgIds: string[];
  /**
   * The flags to evaluate. Only flags that are enabled on the orgs will
   * be returned in the response.
   */
  flags: flags.Flag[];
}

export interface BatchEvaluateFlagsResponse {
  flags: BatchEvaluateFlagsResponse.OrgFlag[];
}

export namespace BatchEvaluateFlagsResponse {
  export interface OrgFlag {
    orgId: string;
    /** Enabled flags for the org, restricted to those provided in the request. */
    flags: flags.FlagsProto | null;
    /**
     * If non-zero, indicates that there was an issue evaluating flags for
     * org. Based on the code, evaluation may need to be retried.
     */
    statusCode: number;
  }
}

export interface UpdateCustomSeatRequestConfigRequest {
  orgId: string;
  enabled: boolean | null;
  text: string | null;
  url: string | null;
}

export interface UpdateSessionOverageConfigRequest {
  entityId: OrgOrUmbrellaID | null;
  overageAllowed: boolean | null;
  blockLimit: number | null;
}

export interface UpdateNotificationConfigRequest {
  orgId: string;
  quotaEmailsDisabled: boolean | null;
  nearQuotaEmailThreshold: number | null;
  dataCaptureStoppedDisabled: boolean | null;
}

export interface UpdateDataExportRequest {
  orgId: string;
  frequencyMinutes: number;
}

export interface UpdateOrgAdminInfoRequest {
  orgId: string;
  name: string | null;
  size: number | null;
  industry: string | null;
  benchmarkingDisabled: boolean | null;
  domain: string | null;
}

export interface UpdateSubscriptionDetailsRequest {
  entityId: OrgOrUmbrellaID | null;
  customerId: string | null;
  subId: string | null;
  invoiceName: string | null;
  invoiceInfo: string | null;
  incrementChargeFailures: boolean | null;
  resetChargeFailures: boolean | null;
  incrementOverageChargeFailures: boolean | null;
  resetOverageChargeFailures: boolean | null;
}

export interface UpdateSubscriptionDetailsResponse {
  subDetails: SubscriptionDetails | null;
}

export interface UpdateDeletionTrailingEdgeRequest {
  orgId: string;
  deletionTrailingEdge: protobuf.timestamp | null;
}

export interface GetUmbrellaRequest {
  umbrellaId: string;
  includeOrgInvites: boolean;
  /** By default we fetch all orgs for the Umbrella. But if true, will exclude them */
  excludeOrgs: boolean;
}

export interface PaymentInfoResponse {
  entityId: OrgOrUmbrellaID | null;
  cardInfo: CardInfo | null;
  invoiceEmail: string;
  stripePublishableToken: string;
}

export interface InvoiceResponse {
  name: string;
  info: string;
  email: string;
  invoices: Invoice[];
}

export interface GetSeatRequest {
  seatId: SeatID | null;
  /** Return the seat's flags merged with the org's flags. */
  includeMergedOrgFlags: boolean;
  /** Include user provided first and last name. */
  includeNames: boolean;
}

export interface UpdateAuthSettingsRequest {
  orgId: string;
  /** Will set the AuthMethod on the Org to use Google */
  googleAuthUpdate?: UpdateAuthSettingsRequest.GoogleAuthUpdate | null;
  /** Will set the AuthMethod on the Org to use Auth0 using the settings provided in the message. */
  auth0Update?: UpdateAuthSettingsRequest.Auth0Update | null;
  /** This will reset the AuthMethod to FullStory (email/password) */
  resetToDefault?: boolean;
}

export namespace UpdateAuthSettingsRequest {
  export interface GoogleAuthUpdate {
    /** If true, any person logging into the org will have to go through Google authentication */
    enforced: boolean;
  }

  export interface Auth0Update {
    /** If true, any person (except guests) logging into the org will have to go through Auth0 authentication */
    enforced: boolean;
    /**
     * Identifier for an existing connection. If this value is zero then it's assumed that we want to continue
     * to use whatever connection id has already been configured for the org.
     */
    connectionId: protobuf.int64;
    /**
     * If true, users that successfully authenticate with Auth0 but do not have a seat can get a
     * seat automatically provisioned when they try to login.
     */
    autoProvision: boolean;
    /**
     * If true, users that log out will be redirected to the custom sign out URL associated with their SAML
     * connection instead of to the FullStory SSO login page.
     */
    ssoCustomSignOutEnabled: boolean;
    /** If true, role mapping will be enabled for this org. Users roles will be controlled by the idp associated with this connection */
    roleMapping: boolean;
  }

  export enum update {
    /** Will set the AuthMethod on the Org to use Google */
    googleAuthUpdate = 2,
    /** Will set the AuthMethod on the Org to use Auth0 using the settings provided in the message. */
    auth0Update = 3,
    /** This will reset the AuthMethod to FullStory (email/password) */
    resetToDefault = 4
  }

  export function update_oneof(m: UpdateAuthSettingsRequest): { opt: update.auth0Update, val: UpdateAuthSettingsRequest.Auth0Update } | { opt: update.googleAuthUpdate, val: UpdateAuthSettingsRequest.GoogleAuthUpdate } | { opt: update.resetToDefault, val: boolean } | null {
    if (m.googleAuthUpdate != null) { return { opt: update.googleAuthUpdate, val: m.googleAuthUpdate } }
    if (m.auth0Update != null) { return { opt: update.auth0Update, val: m.auth0Update } }
    if (m.resetToDefault != null) { return { opt: update.resetToDefault, val: m.resetToDefault } }
    return null;
  }
}

export interface GenerateScimApiTokenRequest {
  orgId: string;
}

export interface GenerateScimApiTokenResponse {
  token: string;
  suffix: string;
}

export interface GetScimApiTokenMetadataRequest {
  orgId: string;
}

export interface GetScimApiTokenMetadataResponse {
  suffix: string;
}

export interface GetScimApiEnabledRequest {
  orgId: string;
}

export interface GetScimApiEnabledResponse {
  enabled: boolean;
}

export interface GetScimApiEnabledForUmbrellaRequest {
  umbrellaId: string;
}

export interface GetScimApiEnabledForUmbrellaResponse {
  orgs: GetScimApiEnabledForUmbrellaResponse.OrgScimApiEnabled[];
}

export namespace GetScimApiEnabledForUmbrellaResponse {
  export interface OrgScimApiEnabled {
    orgId: string;
    enabled: boolean;
  }
}

export interface UpdateCustomVarsRequest {
  orgId: string;
  updates: UpdateCustomVarsRequest.CustomVarUpdate[];
}

export namespace UpdateCustomVarsRequest {
  export interface CustomVarUpdate {
    varName: string;
    /** Include in list of hidden custom vars. */
    hidden: boolean;
  }
}

export interface GetSeatsRequest {
  entityId: OrgOrUmbrellaID | null;
  /** Return the seat's flags merged with the org's flags. */
  includeMergedOrgFlags: boolean;
  /** If no roles are provided, return all seats */
  roles: Role[];
  /** Include user-provided first and last name. */
  includeNames: boolean;
}

export interface SeatsAndInvitesResponse {
  seats: Seat[];
  invites: Invite[];
}

export interface CreateInviteRequest {
  orgId: string;
  email: string;
  role: Role;
  invitedBy: string;
}

export interface CreateInviteResponse {
  invite: Invite | null;
  inviteToken: AuthToken | null;
  /** @deprecated */
  auth0ProviderId: protobuf.int64 | null;
}

export interface BatchCreateInvitesRequest {
  orgId: string;
  emailsAndRoles: BatchCreateInvitesRequest.EmailAndRole[];
  invitedBy: string;
}

export namespace BatchCreateInvitesRequest {
  export interface EmailAndRole {
    email: string;
    role: Role;
  }
}

export interface BatchCreateInvitesResponse {
  invites: BatchCreateInvitesResponse.InviteInfo[];
  errors: BatchCreateInvitesResponse.InviteError[];
  warnings: BatchCreateInvitesResponse.InviteWarning[];
  formerGuests: BatchCreateInvitesResponse.FormerGuestInfo[];
}

export namespace BatchCreateInvitesResponse {
  export interface InviteInfo {
    invite: Invite | null;
    inviteToken: AuthToken | null;
  }

  export interface FormerGuestInfo {
    email: string;
    role: Role;
    inviteToken: AuthToken | null;
  }

  export enum InviteErrorType {
    INVITE_ERROR_UNKNOWN = 0,
    INVITE_ERROR_INVALID_EMAIL = 1,
    INVITE_ERROR_INVALID_ROLE = 2,
    INVITE_ERROR_SEAT_EXISTS = 3,
    INVITE_ERROR_EXCEEDS_SEAT_LIMIT = 4
  }

  export enum InviteWarningType {
    INVITE_WARNING_UNKNOWN = 0,
    INVITE_WARNING_DUPLICATE = 1
  }

  export interface InviteError {
    email: string;
    error: BatchCreateInvitesResponse.InviteErrorType;
  }

  export interface InviteWarning {
    email: string;
    warning: BatchCreateInvitesResponse.InviteWarningType;
  }
}

export interface CreateInviteError {
  reason: CreateInviteError.Reason;
}

export namespace CreateInviteError {
  export enum Reason {
    UNKNOWN = 0,
    USER_EXISTS = 1,
    NO_MORE_SEATS = 2
  }
}

export interface RevokeInviteRequest {
  orgId: string;
  email: string;
}

export interface CreateUmbrellaFromOrgRequest {
  /** The user-visible name of the Umbrella */
  name: string;
  /**
   * Initially create an Umbrella from a single Org. The org's PlanConfig
   * will be used to initialize the Umbrella, with all sessions/seats
   * allocated to the org, and the org's payment info will also be
   * transferred.
   */
  orgId: string;
  /** An admin for the org that is requesting to create an Umbrella over the org. */
  creator: string;
}

export interface EnumerateOrgIDsRequest {
  stages: PlanStage[];
}

export interface AddNewOrgToUmbrellaRequest {
  umbrellaId: string;
  orgName: string;
  /** Email of the creator */
  creator: string;
  /** Provision sessions. */
  sessions: protobuf.int64;
}

export interface AddNewOrgToUmbrellaResponse {
  newOrg: Org | null;
}

export interface CancelUmbrellaOrgsRequest {
  umbrellaId: string;
  orgIds: string[];
}

export interface UpdateUmbrellaMetadataRequest {
  umbrellaId: string;
  /** New Umbrella name */
  name: string;
}

export interface FreemiumSubscribeRequest {
  entityId: OrgOrUmbrellaID | null;
}

export interface UpdatePaymentRequest {
  entityId: OrgOrUmbrellaID | null;
  /** The email to send invoices and receipts */
  invoiceEmail: string;
  /** The stripe-generated payment token (stripe saves the CC info) */
  paymentToken: string;
}

export interface StripeError {
  /** Payment provider responded with a failure status */
  apiError: boolean;
  /** User message returned from payment provider */
  stripeMessage: string;
}

export interface UpdateBillingInfoRequest {
  entityId: OrgOrUmbrellaID | null;
  /** Contact email for the credit card */
  invoiceEmail: string;
}

export interface UpdateUmbrellaAllocationRequest {
  umbrellaId: string;
  /**
   * Map of org ID to the number of allocated sessions
   * Orgs not included in the map will not be changed but will
   * count towards total for Umbrella.
   */
  sessions: { [key: string]: protobuf.int64 };
}

export interface UpdateUmbrellaAllocationResponse {
  /**
   * Map of org ID to the number of allocated sessions.
   * All orgs under the Umbrella are listed.
   */
  sessions: { [key: string]: protobuf.int64 };
  /** Remaining unallocated sessions */
  freeSessions: protobuf.int64;
}

export interface UpdateEmailStatusRequest {
  orgId: string;
  /** Any dates that are unset will not be modified */
  updates: EmailStatus | null;
}

export interface UpdateOrgLevel0Request {
  orgId: string;
  /** This is a wrapper in case we ever have other fields to update separately */
  completedOnboardingVersion: number | null;
  newFreemium: boolean;
  acceptedTermsVersion: number | null;
  setupStage: SetupStage;
  completedPrivacyOnboarding: boolean;
}

export interface UpdateRequiresDeviceVerificationRequest {
  orgId: string;
  enabled: boolean;
}

export interface UpdateSeatsForPersonInUmbrellaRequest {
  /** Key is org ID and value is role for that org */
  orgRoles: { [key: string]: Role };
  seatsToDelete: string[];
  /** The umbrella that the orgs must be under */
  umbrellaId: string;
  /** Email for the person */
  email: string;
  /** Email of the person updating the seats */
  inviterEmail: string;
}

export interface UpdateSeatsForPersonInUmbrellaResponse {
  /** The umbrella that the given orgs must be under. */
  umbrellaId: string;
  /** The new state of the person's seats. Includes all seats even those not in the Umbrella. */
  updatedSeats: Seat[];
  /** The name of the umbrella as set by the umbrella manager */
  umbrellaName: string;
  /** The orgs names to which the person was added */
  addedOrgNames: string[];
  /** In case of partial failure, orgs that did not have enough seats to complete the update. */
  notEnoughSeats: string[];
  /** In case of partial failure, map of orgId to error message. */
  serverErrors: { [key: string]: string };
}

export interface UpdateScimManagedSeatRequest {
  email: string;
  orgId: string;
  firstName: string;
  lastName: string;
  role: Role;
  disabled: boolean;
  isScimManaged: boolean;
}

export interface UpdateSeatForPersonRequest {
  /** UmbrellaManager role not allowed. (Use ChangeRoleToUmbrellaManager) */
  updateRole?: Role;
  delete?: boolean;
  /** Must not be the current logged-in user. */
  email: string;
  orgId: string;
  inviterEmail: string;
}

export namespace UpdateSeatForPersonRequest {
  export enum action {
    /** UmbrellaManager role not allowed. (Use ChangeRoleToUmbrellaManager) */
    updateRole = 1,
    delete = 2
  }

  export function action_oneof(m: UpdateSeatForPersonRequest): { opt: action.delete, val: boolean } | { opt: action.updateRole, val: Role } | null {
    if (m.updateRole != null) { return { opt: action.updateRole, val: m.updateRole } }
    if (m.delete != null) { return { opt: action.delete, val: m.delete } }
    return null;
  }
}

export interface UpdateSeatForPersonResponse {
  inviteToken: AuthToken | null;
  /** @deprecated */
  auth0ProviderId: protobuf.int64 | null;
}

export interface UpdateSeatForPersonError {
  outOfSeats: boolean;
}

export interface ChangeRoleToUmbrellaManagerRequest {
  email: string;
  umbrellaId: string;
  inviter: string;
}

export interface ChangeRoleToUmbrellaManagerError {
  errorReason: ChangeRoleToUmbrellaManagerError.ErrorReason;
}

export namespace ChangeRoleToUmbrellaManagerError {
  export enum ErrorReason {
    UNKNOWN = 0,
    NOT_ENOUGH_SEATS_IN_ORG = 1
  }
}

export interface UpdateSeatLastActivityRequest {
  seatId: SeatID | null;
  lastActivity: protobuf.timestamp | null;
}

export interface UpdateSeatDisabledRequest {
  seatId: SeatID | null;
  disabled: boolean;
}

export interface OverrideFlagsErrorDetails {
  /**
   * Multi failures
   * Orgs that DNE
   */
  notFound: string[];
  /** Map of orgId to error message for orgs that could not be updated. */
  failures: { [key: string]: string };
}

export interface MarkOrgNukingRequest {
  orgId: string;
  /**
   * This indicates that the caller intends to try to delete/nuke the org, even if it
   * was already marked as nuking. This helps track how many attempts are made to nuke
   * an org, so we can alert if there is a persistent problem with deleting an org.
   * 
   * The first call to MarkOrgNuking, that actually changes the flag on the org, will
   * increment the number of attempts to one. Subsequent calls to MarkOrgNuking will
   * also increment the count only if force = true.
   */
  force: boolean;
}

export interface MarkOrgNukingResponse {
  /**
   * True if the org was marked as "nuking"; false it the org was already marked and
   * did not need to be updated. If the request included force = true, this will
   * always return true unless the org has already been fully deleted and tombstoned.
   */
  applied: boolean;
  /** The number of prior attempts to nuke the org. */
  numDeleteAttempts: number;
}

export interface TombstoneOrgResponse {
  /**
   * True if the org was tombstoned; false it the org was already tombstoned and did
   * not need to be updated.
   */
  applied: boolean;
}

export interface ProvisionRequest {
  creatorEmail: string;
  orgName: string;
  searchCluster: string;
  optOrgId: string;
  /**
   * If set to true, and if the orgs service is running in the na1 data realm, then we will not wrap the given optional
   * org ID with the `o-` prefix and `-{realmId}` suffix (i.e. the new format for org IDs necessitated by our expansion
   * to Europe). It's sometimes useful to be able to generate legacy org IDs. For example, when:
   * - Creating the usual `local` and `testdrive` orgs as part of setting up local dev or playpen
   * - Re-provisioning an existing org in another environment for replication purposes
   */
  forceLegacyFormatOptOrgId: boolean;
  allowDupes: boolean;
  /** Optional */
  firstName: string;
  /** Optional */
  lastName: string;
  /** Optional */
  company: string;
  /** Optional */
  couponCode: string;
  /** If true, will skip trial and make org Freemium */
  freemium: boolean;
  country: string;
  platform: Platform;
  /** Optional. Creates the org under an existing umbrella. */
  underUmbrella: ProvisionRequest.UmbrellaOrg | null;
}

export namespace ProvisionRequest {
  export interface UmbrellaOrg {
    umbrellaId: string;
    orgSessions: protobuf.int64;
  }
}

export interface ProvisionResponse {
  orgId: string;
  org: Org | null;
}

export interface CancelResponse {
  name: string;
  wasSubscribed: boolean;
}

export interface ShareSettingsUpdate {
  orgId: string;
  domainUpdates: ListUpdate | null;
  shareSessionEnabled: boolean | null;
}

export interface UpdateShareSettingsResponse {
  domains: string[];
  shareSessionEnabled: boolean;
}

export interface UpdateJoinSettingsRequest {
  orgId: string;
  domainUpdates: ListUpdate | null;
  joinOrgEnabled: boolean | null;
}

export interface UpdateJoinSettingsResponse {
  domains: string[];
  joinOrgEnabled: boolean;
}

export interface UpdateInactivityTimeoutSettingsRequest {
  orgId: string;
  userInactivityTimeout: number;
  adminInactivityTimeout: number;
}

export enum ContactType {
  CONTACT_UNKNOWN = 0,
  CONTACT_NEW_FEATURES = 2,
  CONTACT_CRITICAL_INCIDENTS = 3,
  CONTACT_PRODUCT_UPDATES = 4
}

export interface ContactInformation {
  contactType: ContactType;
  contactEmails: string[];
  userEntered: boolean;
}

export interface GetContactsRequest {
  entityId: OrgOrUmbrellaID | null;
}

export interface GetContactsResponse {
  contacts: ContactInformation[];
}

export interface UpdateContactsRequest {
  entityId: OrgOrUmbrellaID | null;
  contactUpdates: UpdateContactsRequest.ContactUpdate[];
}

export namespace UpdateContactsRequest {
  export interface ContactUpdate {
    contactType: ContactType;
    /** The given email must have a seat on the org or umbrella */
    addEmails: string[];
    /** Any emails that are not already set will be ignored */
    removeEmails: string[];
  }
}

export interface GetTeamsForDomainRequest {
  /**
   * Should be a valid domain i.e. everything that comes after "@" in an email address,
   * e.g. example.com
   */
  emailDomain: string;
  fetchFromOtherRealms: boolean;
}

export interface GetTeamsForDomainResponse {
  teams: GetTeamsForDomainResponse.Team[];
}

export namespace GetTeamsForDomainResponse {
  export interface Team {
    teamName: string;
    teamDisplayName: string;
    teamRealm: string;
  }
}

export interface GetOrgsForTeamRequest {
  teamName: string;
}

export interface GetOrgsForTeamResponse {
  orgIds: string[];
}

export interface AddTeamDomainRequest {
  orgId: string;
  emailDomain: string;
}

export interface RemoveTeamDomainRequest {
  orgId: string;
  /** Remove a single email domain */
  emailDomain?: string;
  /** Remove all domains for the org */
  removeAll?: {} | null;
}

export namespace RemoveTeamDomainRequest {
  export enum remove {
    /** Remove a single email domain */
    emailDomain = 2,
    /** Remove all domains for the org */
    removeAll = 3
  }

  export function remove_oneof(m: RemoveTeamDomainRequest): { opt: remove.emailDomain, val: string } | { opt: remove.removeAll, val: {} } | null {
    if (m.emailDomain != null) { return { opt: remove.emailDomain, val: m.emailDomain } }
    if (m.removeAll != null) { return { opt: remove.removeAll, val: m.removeAll } }
    return null;
  }
}

export interface GetAuthDomainsForOrgResponse {
  /** A list of email domains i.e. everything that comes after the @ */
  emailDomains: string[];
}

export interface ComputePreSsoConnectionInfoRequest {
  orgId: string;
  /** An email domain i.e. everything that comes after the @ */
  emailDomain: string;
}

export interface ComputePreSsoConnectionInfoResponse {
  /** The name for the SSO team, associated with the SSO connection */
  teamName: string;
  /** The FullStory auth0 login URL for the org's SSO connection */
  ssoUrl: string;
  /** A resource identifier for the SAML service provider */
  audienceUrl: string;
  /** A URL pointing to the location of the FullStory SSO signing certificate */
  requestSigningCertificateUrl: string;
}

export interface ProvisionSsoRequest {
  orgId: string;
  /** An email domain i.e. everything that comes after the @ */
  emailDomain: string;
  /** The display name that the user wishes to give their SSO connection */
  teamDisplayName: string;
  /** A string containing the contents of the metadata.xml SSO setup file */
  idpMetadata: string;
}

export interface GetSsoSettingsRequest {
  orgId: string;
  /** An email domain i.e. everything that comes after the @ */
  emailDomain: string;
}

export interface DeprovisionSsoRequest {
  orgId: string;
}

export interface SsoSettings {
  /** A list of email domains i.e. everything that comes after the @ */
  emailDomains: string[];
  /** The name for the SSO team, associated with the SSO connection */
  teamName: string;
  /** The display name for the SSO team that was configured */
  teamDisplayName: string;
  /** The full URL pointing to the location of the branding image associated with the org's team */
  brandingImageUrl: string;
  /** The date/time that the current SSO certificate will expire */
  certExpirationDate: protobuf.timestamp | null;
  /** A flag indicating of SSO JIT provisioning is enabled for the org */
  ssoAutoProvisionEnabled: boolean;
  /** A flag indicating if SSO login is enforced for the org */
  idProviderEnforced: boolean;
  /** A URL pointing the the SSO login page that users can log into FSTA from */
  ssoLoginPageUrl: string;
  /** A flag indicating if SSO role mapping feature should be enabled */
  ssoRoleMapping: boolean;
  /**  A flag indicating whether SCIM provisioning is enabled for the org */
  scimProvisioningEnabled: boolean;
  /** The base URL for the SCIM API for the org. Dynamic for ENV */
  scimApiBaseUrl: string;
}

export interface GetDataExportSettingsRequest {
  orgId: string;
}

export interface GetDataExportSettingsResponse {
  exportFreqMinutes: number;
}

export interface UpdateSsoConfigRequest {
  orgId: string;
  /** The contents of the new SSO certificate */
  pemString: string;
  /** The new display name for the org's team */
  teamDisplayName: string;
  /** Whether or not we should enable JIT/auto SSO provisioning for the org */
  provisioning: UpdateSsoConfigRequest.Provisioning;
  /** Whether or not users are required to use SSO to log into the org */
  required: UpdateSsoConfigRequest.Required;
  /** Whether or not role mapping should be enabled */
  roleMapping: UpdateSsoConfigRequest.RoleMapping;
}

export namespace UpdateSsoConfigRequest {
  export enum Provisioning {
    PROVISION_UNSET = 0,
    AUTO_PROVISION_ENABLED = 1,
    PROVISION_DISABLED = 2,
    PROVISION_WITH_SCIM = 3
  }

  export enum Required {
    REQUIRED_UNSET = 0,
    REQUIRED_ENABLED = 1,
    REQUIRED_DISABLED = 2
  }

  export enum RoleMapping {
    ROLE_MAPPING_UNSET = 0,
    ROLE_MAPPING_ENABLED = 1,
    ROLE_MAPPING_DISABLED = 2
  }
}

export interface UpdateSsoConfigResponse {
  /** The date/time that the new SSO certificate will expire */
  certExpirationDate: protobuf.timestamp | null;
}

export interface UpdateSeatsDisabledRequest {
  /** Org id */
  orgId: OrgID | null;
  /** List of seat id's to not disable */
  excludeSeats: SeatID[];
  /** Should disable */
  disabled: boolean;
}

export interface UpdateOrgCreateSeatsDisabledRequest {
  /** Org is */
  orgId: OrgID | null;
  disabled: boolean;
}

export interface BatchUpdateOrgSeatsRequest {
  orgId: string;
  /** Map email addresses to updates */
  updates: { [key: string]: BatchUpdateOrgSeatsRequest.Update };
}

export namespace BatchUpdateOrgSeatsRequest {
  export enum Status {
    UNSET = 0,
    ENABLED = 1,
    DISABLED = 2
  }

  export interface Update {
    role: Role;
    status: BatchUpdateOrgSeatsRequest.Status;
  }
}

export interface BatchUpdateOrgSeatsResponse {
  updates: BatchUpdateOrgSeatsResponse.Update[];
}

export namespace BatchUpdateOrgSeatsResponse {
  export interface Update {
    email: string;
    inviteToken: AuthToken | null;
  }
}

export interface BatchDeleteSeatsRequest {
  orgId: string;
  emails: string[];
}

export interface GetSeatsAndInvitesRequest {
  entityId: OrgOrUmbrellaID | null;
  filters: GetSeatsAndInvitesRequest.Filter[];
  /** If true, include the user-entered name for each Seat. */
  includeNames: boolean;
  /** If true, return group invites. */
  includeGroups: boolean;
}

export namespace GetSeatsAndInvitesRequest {
  /** RolesFilter tells us to keep seats and invites with the given set of roles. */
  export interface RolesFilter {
    roles: Role[];
  }

  /**
   * LastActivityFilter tells us to keep seats with a LastActivity time, or invites with a Created time, that lie within
   * the specified range.
   */
  export interface LastActivityFilter {
    startTime: protobuf.timestamp | null;
    endTime: protobuf.timestamp | null;
  }

  /** StatusFilter tells us to keep seats that have the given status. */
  export interface StatusFilter {
    disabled: boolean;
    enabled: boolean;
    inviteSent: boolean;
  }

  /** SearchFilter tells us to keep only seats/invites that contain this substring. */
  export interface SearchFilter {
    searchSubstring: string;
  }

  export interface DomainsFilter {
    domains: string[];
  }

  export interface ProvisioningFilter {
    isScimManaged: boolean;
    isNotScimManaged: boolean;
  }

  export interface GroupFilter {
    groups: string[];
  }

  export interface Filter {
    rolesFilter?: GetSeatsAndInvitesRequest.RolesFilter | null;
    lastActivityFilter?: GetSeatsAndInvitesRequest.LastActivityFilter | null;
    statusFilter?: GetSeatsAndInvitesRequest.StatusFilter | null;
    searchFilter?: GetSeatsAndInvitesRequest.SearchFilter | null;
    domainsFilter?: GetSeatsAndInvitesRequest.DomainsFilter | null;
    provisioningFilter?: GetSeatsAndInvitesRequest.ProvisioningFilter | null;
    groupFilter?: GetSeatsAndInvitesRequest.GroupFilter | null;
  }

  export namespace Filter {
    export enum filter {
      rolesFilter = 1,
      lastActivityFilter = 2,
      statusFilter = 3,
      searchFilter = 4,
      domainsFilter = 5,
      provisioningFilter = 6,
      groupFilter = 7
    }

    export function filter_oneof(m: Filter): { opt: filter.domainsFilter, val: GetSeatsAndInvitesRequest.DomainsFilter } | { opt: filter.groupFilter, val: GetSeatsAndInvitesRequest.GroupFilter } | { opt: filter.lastActivityFilter, val: GetSeatsAndInvitesRequest.LastActivityFilter } | { opt: filter.provisioningFilter, val: GetSeatsAndInvitesRequest.ProvisioningFilter } | { opt: filter.rolesFilter, val: GetSeatsAndInvitesRequest.RolesFilter } | { opt: filter.searchFilter, val: GetSeatsAndInvitesRequest.SearchFilter } | { opt: filter.statusFilter, val: GetSeatsAndInvitesRequest.StatusFilter } | null {
      if (m.rolesFilter != null) { return { opt: filter.rolesFilter, val: m.rolesFilter } }
      if (m.lastActivityFilter != null) { return { opt: filter.lastActivityFilter, val: m.lastActivityFilter } }
      if (m.statusFilter != null) { return { opt: filter.statusFilter, val: m.statusFilter } }
      if (m.searchFilter != null) { return { opt: filter.searchFilter, val: m.searchFilter } }
      if (m.domainsFilter != null) { return { opt: filter.domainsFilter, val: m.domainsFilter } }
      if (m.provisioningFilter != null) { return { opt: filter.provisioningFilter, val: m.provisioningFilter } }
      if (m.groupFilter != null) { return { opt: filter.groupFilter, val: m.groupFilter } }
      return null;
    }
  }
}

export interface GetSeatsAndInvitesResponse {
  entities: SeatOrInvite[];
  /** domains is a list of all unique user email address domains, regardless of filters applied */
  domains: string[];
  /** the total number of unfiltered entities */
  totalCount: number;
}

export interface SeatOrInvite {
  seat?: Seat | null;
  invite?: Invite | null;
  groups: string[];
}

export namespace SeatOrInvite {
  export enum entity {
    seat = 1,
    invite = 2
  }

  export function entity_oneof(m: SeatOrInvite): { opt: entity.invite, val: Invite } | { opt: entity.seat, val: Seat } | null {
    if (m.seat != null) { return { opt: entity.seat, val: m.seat } }
    if (m.invite != null) { return { opt: entity.invite, val: m.invite } }
    return null;
  }
}

export interface BatchRevokeInvitesRequest {
  orgId: string;
  emails: string[];
}

export interface ForceTrialExpireRequest {
  orgId: string;
}

export interface UpdateFirstRecordRequest {
  orgId: string;
}

export interface UpdateFirstRecordResponse {
  firstRecord: protobuf.timestamp | null;
}

export interface CreateOrgSeatRequest {
  orgId: string;
  email: string;
  role: Role;
}

/** CreateOrgSeatError is used to return specific errors from CreateOrgSeat via gRPC details. */
export interface CreateOrgSeatError {
  reason: CreateOrgSeatError.Reason;
}

/** CreateOrgSeatError is used to return specific errors from CreateOrgSeat via gRPC details. */
export namespace CreateOrgSeatError {
  export enum Reason {
    UNKNOWN = 0,
    NO_MORE_SEATS = 1
  }
}

export interface UpsertScimManagedSeatRequest {
  orgId: string;
  email: string;
  firstName: string;
  lastName: string;
  role: Role;
  disabled: boolean;
  isScimManaged: boolean;
}

export interface UpsertScimManagedSeatResponse {
  orgId: string;
  email: string;
  firstName: string;
  lastName: string;
  role: Role;
  disabled: boolean;
  isScimManaged: boolean;
}

export interface AnalyzeQuotaRequest {
  orgId: string;
}

export interface AnalyzeQuotaResponse {
  /** Decimal percentage of sessions used on a plan */
  utilizedQuotaPercent: number;
  /** Number of days into current cycle */
  daysIntoQuota: number;
  /** Projected quota utilization percent */
  projectedQuotaUtilization: number;
  /**
   * ProjectedOverageDate is calculated differently depending on the state of the org and session usage, either:
   *   - the date the quota will be reached if under-quota and projected to exceed it
   *   - the date the overage block limit will be reached if over-quota, overages are allowed, and projected to exceed it
   *   - nil otherwise
   */
  projectedOverageDate: protobuf.timestamp | null;
  sessionsUsedToday: protobuf.int64;
}

export interface GetSsoAutoProvisionOrgsRequest {
  teamName: string;
  fetchFromOtherRealms: boolean;
}

export interface GetSsoAutoProvisionOrgsResponse {
  orgIds: string[];
}

export interface GetOrgUsedSeatCountRequest {
  orgId: string;
}

export interface GetOrgUsedSeatCountResponse {
  usedSeatCount: number;
}

export interface GetUmbrellaInviteRequest {
  seatId: SeatID | null;
}

export interface CreateUmbrellaInviteRequest {
  umbrellaId: string;
  email: string;
  orgInvites?: UmbrellaInvite.OrgInvites | null;
  umbrellaManager?: boolean;
  invitedBy: string;
}

export namespace CreateUmbrellaInviteRequest {
  export enum invite {
    orgInvites = 3,
    umbrellaManager = 4
  }

  export function invite_oneof(m: CreateUmbrellaInviteRequest): { opt: invite.orgInvites, val: UmbrellaInvite.OrgInvites } | { opt: invite.umbrellaManager, val: boolean } | null {
    if (m.orgInvites != null) { return { opt: invite.orgInvites, val: m.orgInvites } }
    if (m.umbrellaManager != null) { return { opt: invite.umbrellaManager, val: m.umbrellaManager } }
    return null;
  }
}

export interface CreateUmbrellaInviteResponse {
  umbrellaInvite: UmbrellaInvite | null;
  inviteToken: AuthToken | null;
}

export interface GetSeatsAndInvitesForUmbrellaRequest {
  umbrellaId: string;
  filters: GetSeatsAndInvitesForUmbrellaRequest.Filter[];
}

export namespace GetSeatsAndInvitesForUmbrellaRequest {
  export interface RolesFilter {
    roles: Role[];
  }

  export interface LastActivityFilter {
    startTime: protobuf.timestamp | null;
    endTime: protobuf.timestamp | null;
  }

  export interface StatusFilter {
    disabled: boolean;
    enabled: boolean;
    inviteSent: boolean;
  }

  /** To find a substring match on either name or email. */
  export interface UserSearchFilter {
    searchSubstring: string;
  }

  export interface OrgFilter {
    /** List of org ids to return users that have access to at least one */
    orgIds: string[];
  }

  export interface ProvisioningFilter {
    isScimManaged: boolean;
    isNotScimManaged: boolean;
  }

  export interface Filter {
    rolesFilter?: GetSeatsAndInvitesForUmbrellaRequest.RolesFilter | null;
    lastActivityFilter?: GetSeatsAndInvitesForUmbrellaRequest.LastActivityFilter | null;
    statusFilter?: GetSeatsAndInvitesForUmbrellaRequest.StatusFilter | null;
    userSearchFilter?: GetSeatsAndInvitesForUmbrellaRequest.UserSearchFilter | null;
    orgFilter?: GetSeatsAndInvitesForUmbrellaRequest.OrgFilter | null;
    provisioning?: GetSeatsAndInvitesForUmbrellaRequest.ProvisioningFilter | null;
  }

  export namespace Filter {
    export enum filter {
      rolesFilter = 1,
      lastActivityFilter = 2,
      statusFilter = 3,
      userSearchFilter = 4,
      orgFilter = 5,
      provisioning = 6
    }

    export function filter_oneof(m: Filter): { opt: filter.lastActivityFilter, val: GetSeatsAndInvitesForUmbrellaRequest.LastActivityFilter } | { opt: filter.orgFilter, val: GetSeatsAndInvitesForUmbrellaRequest.OrgFilter } | { opt: filter.provisioning, val: GetSeatsAndInvitesForUmbrellaRequest.ProvisioningFilter } | { opt: filter.rolesFilter, val: GetSeatsAndInvitesForUmbrellaRequest.RolesFilter } | { opt: filter.statusFilter, val: GetSeatsAndInvitesForUmbrellaRequest.StatusFilter } | { opt: filter.userSearchFilter, val: GetSeatsAndInvitesForUmbrellaRequest.UserSearchFilter } | null {
      if (m.rolesFilter != null) { return { opt: filter.rolesFilter, val: m.rolesFilter } }
      if (m.lastActivityFilter != null) { return { opt: filter.lastActivityFilter, val: m.lastActivityFilter } }
      if (m.statusFilter != null) { return { opt: filter.statusFilter, val: m.statusFilter } }
      if (m.userSearchFilter != null) { return { opt: filter.userSearchFilter, val: m.userSearchFilter } }
      if (m.orgFilter != null) { return { opt: filter.orgFilter, val: m.orgFilter } }
      if (m.provisioning != null) { return { opt: filter.provisioning, val: m.provisioning } }
      return null;
    }
  }
}

export interface GetSeatsAndInvitesForUmbrellaResponse {
  users: GetSeatsAndInvitesForUmbrellaResponse.UserInfo[];
}

export namespace GetSeatsAndInvitesForUmbrellaResponse {
  export interface UserInfo {
    email: string;
    /** SeatOrInvite of all the seats & invites a user has on the umbrella */
    seats: SeatOrInvite[];
    firstName: string;
    lastName: string;
    umbrellaInvite: boolean;
  }
}

export interface GetInvoiceRequest {
  invoiceId: string;
}

export interface BatchUpdateUsersInUmbrellaRequest {
  umbrellaId: string;
  users: string[];
  action: BatchUpdateUsersInUmbrellaRequest.Action;
}

export namespace BatchUpdateUsersInUmbrellaRequest {
  export enum Action {
    UNSET = 0,
    ENABLE = 1,
    DISABLE = 2,
    REMOVE = 3
  }
}

export interface EntityName {
  name: string;
}

export interface RevokeUmbrellaInviteRequest {
  umbrellaId: string;
  email: string;
}

export interface GetActiveOrgSeatForPersonRequest {
  email: string;
}

export interface GetActiveOrgSeatForPersonResponse {
  orgId: string;
  orgName: string;
}

export interface GetOrgIdsForPersonRequest {
  email: string;
}

export interface GetOrgIdsForPersonResponse {
  orgIds: string[];
}

export enum ExperimentFeature {
  FEATURE_INVALID = 0,
  /** If FEATURE_ALL is set to opted out, then all other features are opted out */
  FEATURE_ALL = 4,
  /** Used for session summary on notes and other single session summary items */
  FEATURE_SESSION_SUMMARY = 1,
  FEATURE_SELECTOR_TRIM = 2,
  FEATURE_SUGGESTED_ELEMENTS = 3,
  FEATURE_SUGGESTED_LABELS = 5,
  FEATURE_PLAYLIST_SUMMARIES = 6,
  FEATURE_SUGGESTED_PAGES = 7
}

export interface SetExperimentOptedOutRequest {
  entityId: OrgOrUmbrellaID | null;
  feature: ExperimentFeature;
  optedOut: boolean;
}

export interface GetExperimentOptedOutRequest {
  entityId: OrgOrUmbrellaID | null;
  feature: ExperimentFeature;
}

export interface GetExperimentOptedOutResponse {
  optedOut: boolean;
}

export interface GetAllExperimentsOptedOutRequest {
  entityId: OrgOrUmbrellaID | null;
}

export interface GetAllExperimentsOptedOutResponse {
  optOuts: GetAllExperimentsOptedOutResponse.OptOut[];
}

export namespace GetAllExperimentsOptedOutResponse {
  export interface OptOut {
    feature: ExperimentFeature;
    optedOut: boolean;
  }
}
